import { siteInfo } from '@/mocks/site';

interface SEOSchemaProps {
  type: 'website' | 'webpage' | 'organization' | 'article' | 'faqpage' | 'breadcrumblist';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data }: SEOSchemaProps) {
  let schema: Record<string, unknown>;

  switch (type) {
    case 'organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        email: siteInfo.email,
        description: siteInfo.description,
        address: {
          '@type': 'PostalAddress',
          addressLocality: '上海',
          addressCountry: 'CN',
        },
      };
      break;
    case 'website':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      };
      break;
    case 'webpage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: data?.name || siteInfo.name,
        description: data?.description || siteInfo.description,
        url: data?.url || siteInfo.url,
        ...(data?.breadcrumb && { breadcrumb: data.breadcrumb }),
      };
      break;
    case 'article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: data?.headline,
        description: data?.description,
        author: {
          '@type': 'Person',
          name: data?.author,
        },
        datePublished: data?.datePublished,
        dateModified: data?.dateModified || data?.datePublished,
        image: data?.image,
        ...(data?.publisher && {
          publisher: {
            '@type': 'Organization',
            name: data.publisher,
          },
        }),
      };
      break;
    case 'faqpage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (data?.questions as Array<{ question: string; answer: string }>)?.map((q) => ({
          '@type': 'Question',
          name: q.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: q.answer,
          },
        })),
      };
      break;
    default:
      schema = {};
  }

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}